import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Label for Missing Ref Report nav item.
 */
export const schema = z.string();

export type ReferenceNumReportLabel = z.infer<typeof schema>;

export const definition = define({
  key: 'reference_num_report_label',
  schema,
  label: 'Missing Ref Report Label',
  description: 'A client-specific label to display for the missing reference number report.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.REFERENCE_NUMBER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 'Missing Ref Report',
});
